module.exports = __webpack_public_path__ + "img/visa.797fc7dd.jpg";